define('helperContent-getQuizGameMap',['helperContent-getEntity'], function(getEntity) {
    'use strict';

    var getQuizGameMap = function(trainingEntities) {
        var gameMap = [];

        if (Array.isArray(trainingEntities) && trainingEntities.length) {
            var i = 0,
                id = '',
                len = 0,
                arr = [],
                item = null;

            if (trainingEntities[0].hasOwnProperty('contentEntityId') && trainingEntities[0].contentEntityId) {
                id = trainingEntities[0].contentEntityId;

                (function f(entities, id) {
                    var i = 0,
                        nextID = '',
                        childID = '',
                        answers = [],
                        entity = getEntity(id, trainingEntities),
                        content = (entity && entity.hasOwnProperty('contentEntity') && entity.contentEntity),
                        getNextID = function(arr, indx) {
                            var no = indx + 1 || 0;

                            if (arr && Array.isArray(arr) && arr.length > no) {
                                return arr[no].contentEntityId;
                            }

                            return '';
                        },
                        objInArray = function(obj, arr) {
                            var i = (arr && Array.isArray(arr)) ? arr.length : 0;

                            while(i--) {
                                if (arr[i].id === obj.id && arr[i].value === obj.value ) {
                                    return true;
                                }
                            }

                            return false;
                        };

                    if (content) {

                        if (content.naviTargetId) {

                            item = {
                                id: id,
                                value: content.naviTargetId
                            };

                            if (!objInArray(item, arr)) {
                                arr.push(item);
                                f(entities, content.naviTargetId);
                            }

                        } else {

                            if (entity.hasOwnProperty('children') && Array.isArray(entity.children) && entity.children.length) {
                                var children = entity.children.slice(0),
                                    shuffleTasks = (entity.contentEntity.shuffleTasks === true) ? true : false,
                                    taskToShow = (entity.contentEntity.taskCountToShow) ? entity.contentEntity.taskCountToShow : 0;

                                if (shuffleTasks) {
                                    children.shuffle();
                                }

                                if (taskToShow > 0 && children.length > taskToShow) {
                                    children = children.splice(0, taskToShow);
                                }

                                if (children[0].hasOwnProperty('contentEntityId')) {
                                    childID = children[0].contentEntityId;
                                }

                                if (childID) {
                                    item = {
                                        id: id,
                                        value: childID
                                    };

                                    if (!objInArray(item, arr)) {
                                        f(children, childID);
                                    }

                                }

                            }

                            if (entities.indexOf(entity) < entities.length) {

                                nextID = getNextID(entities, entities.indexOf(entity));

                                item = {
                                    id: id,
                                    value: nextID
                                };

                                if (!objInArray(item, arr)) {
                                    arr.push(item);
                                    f(entities, nextID);
                                }

                            }

                        }

                        if (entity.hasOwnProperty('answers') && Array.isArray(entity.answers) && entity.answers.length) {
                            answers = entity.answers;
                            len = answers.length;

                            for(i = 0; i < len; i++) {
                                nextID = (answers[i] && answers[i].hasOwnProperty('naviTargetId')) ? answers[i].naviTargetId : '';

                                item = {
                                    id: id,
                                    value: nextID
                                };

                                if (!objInArray(item, arr)) {
                                    arr.push(item);
                                    f(trainingEntities, nextID);
                                }

                            }

                        }

                    }

                })(trainingEntities, id);
            }

            len = arr.length;
            for( ; i < len; i++) {
                if (gameMap.indexOf(arr[i].id) === -1) {
                    gameMap.push(arr[i].id);
                }
            }

        }

        return gameMap;
    };

    return getQuizGameMap;
});

